module.exports = __webpack_public_path__ + "static/media/Safe-T4.ca802f76.JPG";